import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { PaginationParams, toHttpParams } from '../model/api/pagination-params';
import { DataRest, IdDataRest, PaginatedTickets, TicketData, TicketsData } from '../model/api/data-rest';
import { environment } from 'src/environments/environment';
import { resources } from './api';
import { Ticket } from '../model/ticket';


@Injectable({
    providedIn: 'root'
})
export class TicketService {

    constructor(
        private http: HttpClient,
    ) {
    }

    getTickets(paging?: PaginationParams, filter?: string, flagClosed?: number): Observable<PaginatedTickets> {
        let params: HttpParams;
        if (paging) {
            params = toHttpParams(paging);
        }
        if (filter) {
            params = params.append('filter', filter);
        }
        if (flagClosed !== undefined && flagClosed >= 0) {
            params = params.append('flagClosed', flagClosed);
        }
        return this.http.get<PaginatedTickets>(`${environment.apiUrl}${resources.get('support')}${resources.get('ticket')}`, { params });
    }

    getAllTickets(): Observable<TicketsData> {
        return this.http.get<TicketsData>(`${environment.apiUrl}${resources.get('support')}${resources.get('ticket')}`);
    }

    getTicket(id: number): Observable<TicketData> {
        return this.http.get<TicketData>(`${environment.apiUrl}${resources.get('support')}${resources.get('ticket')}/${id}`);
    }

    addTicket(ticket: Ticket): Observable<IdDataRest> {
        return this.http.post<IdDataRest>(`${environment.apiUrl}${resources.get('support')}${resources.get('ticket')}`, ticket);
    }

    closeTicket(ticketId: number, closingNote?: string | null) {
        const payload = {
            ClosingNote: closingNote?.trim() || null
        };
        return this.http.patch<DataRest>(
            `${environment.apiUrl}${resources.get('support')}${resources.get('ticket')}/${ticketId}${resources.get('close')}`,
            payload
        );
    }
}
